import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../pages/HomePage.vue'
import MarketPage from '../pages/MarketPage.vue'
import CartPage from '../pages/CartPage.vue'
import AuthCallbackPage from '../pages/AuthCallbackPage.vue'
import ProfilePage from '../pages/ProfilePage.vue'
import LegalPage from '../pages/LegalPage.vue'
import { getLegalPath } from './legalLinks.js'
import adminRoutes from '../admin/routes'
import { clearAdminSession, isAdminTokenExpired } from '../admin/utils/adminSession'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/market',
    name: 'Market',
    component: MarketPage
  },
  {
    path: '/cart',
    name: 'Cart',
    component: CartPage
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: AuthCallbackPage
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage
  },
  {
    path: '/page/:slug',
    name: 'StaticPage',
    component: LegalPage
  },
  // Legacy aliases for backward compatibility
  { path: '/terms', alias: ['/terms-of-use', '/terms-and-conditions'], beforeEnter: async () => getLegalPath('terms'), component: LegalPage },
  { path: '/privacy', alias: ['/privacy-policy', '/privacy-notice'], beforeEnter: async () => getLegalPath('privacy'), component: LegalPage },
  { path: '/cookies', alias: ['/cookie-policy', '/cookie-notice'], beforeEnter: async () => getLegalPath('cookies'), component: LegalPage },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../pages/RegisterPage.vue')
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: () => import('../pages/VerifyEmailPage.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../pages/ForgotPasswordPage.vue')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('../pages/ResetPasswordPage.vue')
  },
  ...adminRoutes
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    return savedPosition || { top: 0 }
  }
})

// Admin route guard
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAdmin) {
    const adminToken = localStorage.getItem('admin_token')
    if (!adminToken || isAdminTokenExpired(adminToken)) {
      clearAdminSession()
      return next({
        name: 'AdminLogin',
        query: {
          ...(adminToken ? { reason: 'session-expired' } : {}),
          redirect: to.fullPath,
        },
      })
    }
  }
  next()
})

export default router
